<template>
  <div class="tags">
    <h4>{{ $t('blog.tags.see_more') }}</h4>
    <Tag v-for="tag in tags" :key="tag.id" :value="tag"/>
  </div>
</template>

<script>
import Tag from './Tag';

export default {
  name: 'Tags',
  components: {
    Tag,
  },
  props: {
    value: {
      type: Array,
      required: true,
      description: 'Array of Tag Objects',
    },
  },
  computed: {
    tags() {
      return this.value;
    },
  },
};
</script>

<style scoped>
.tags {
  margin-top: 2rem;
  display: flex;
  flex-wrap: wrap;
}
.tags h4 {
  width: 100%;
}
</style>
